import { Stack, Typography } from '@mui/material';
import {
  FacilityCategoryIcon,
  PartCategoryIcon,
  StatusCategoryIcon,
  TypeCategoryIcon,
} from '../../../layouts/dashboard/nav/IconButton';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ width: '100%', overflow: 'auto' }}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

export function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export const categoryList = [
  {
    index: 0,
    id: `tab-0`,
    icon: <TypeCategoryIcon />,
    tab: (
      <Stack sx={{ pl: 3 }}>
        <Typography>구분</Typography>
        <b>공원, 산책로, 그외 기타 장소를 등록 및 편집합니다.</b>
      </Stack>
    ),
    mobile: <Typography fontSize="14px">구분</Typography>,
  },
  {
    index: 1,
    id: `tab-1`,
    icon: <FacilityCategoryIcon />,
    tab: (
      <Stack sx={{ pl: 3 }}>
        <Typography>운동기구</Typography>
        <b>
          일반형, 복합형으로 분류되어있는 운동기구 종류를 등록 및 편집합니다.
        </b>
      </Stack>
    ),
    mobile: <Typography fontSize="14px">운동기구</Typography>,
  },
  {
    index: 2,
    id: `tab-2`,
    icon: <StatusCategoryIcon />,
    tab: (
      <Stack sx={{ pl: 3 }}>
        <Typography>상태비고</Typography>
        <b>점검 상태를 등록 및 편집합니다.</b>
      </Stack>
    ),
    mobile: <Typography fontSize="14px">상태비고</Typography>,
  },
  {
    index: 3,
    id: `tab-3`,
    icon: <PartCategoryIcon />,
    tab: (
      <Stack>
        <Typography>부서</Typography>
        <b>관리부서를 등록 및 편집합니다.</b>
      </Stack>
    ),
    mobile: <Typography fontSize="14px">부서</Typography>,
  },
];
